module.exports = __webpack_public_path__ + "static/bracu-3-f0d1808d4ed07ee9d4b7323a1a5f99b5.jpg";